// src/config/timezone.ts

import { i18n } from "@/plugins/vueI18n";

export interface TimeZoneConfig {
  timeZoneId: string;
  country: string;
  countryCode: string;
  timeZoneName: string;
  abbreviation: string;
  representativeCity: string;
  utcOffset: string;
}

export const timeZones: TimeZoneConfig[] = [
  // United States
  {
    timeZoneId: "America/Anchorage",
    country: "United States",
    countryCode: "US",
    timeZoneName: "Alaska Time",
    abbreviation: "AKT (AKST/AKDT)",
    representativeCity: "Anchorage",
    utcOffset: "UTC-09:00",
  },
  {
    timeZoneId: "America/Chicago",
    country: "United States",
    countryCode: "US",
    timeZoneName: "Central Time",
    abbreviation: "CT (CST/CDT)",
    representativeCity: "Chicago",
    utcOffset: "UTC-06:00",
  },
  {
    timeZoneId: "America/New_York",
    country: "United States",
    countryCode: "US",
    timeZoneName: "Eastern Time",
    abbreviation: "ET (EST/EDT)",
    representativeCity: "New York, Washington",
    utcOffset: "UTC-05:00",
  },
  {
    timeZoneId: "Pacific/Honolulu",
    country: "United States",
    countryCode: "US",
    timeZoneName: "Hawaii Time",
    abbreviation: "HT (HST/HDT)",
    representativeCity: "Honolulu",
    utcOffset: "UTC-10:00",
  },
  {
    timeZoneId: "America/Denver",
    country: "United States",
    countryCode: "US",
    timeZoneName: "Mountain Time",
    abbreviation: "MT (MST/MDT)",
    representativeCity: "Denver",
    utcOffset: "UTC-07:00",
  },
  {
    timeZoneId: "America/Los_Angeles",
    country: "United States",
    countryCode: "US",
    timeZoneName: "Pacific Time",
    abbreviation: "PT (PST/PDT)",
    representativeCity: "Los Angeles",
    utcOffset: "UTC-08:00",
  },
  // Canada
  {
    timeZoneId: "America/Halifax",
    country: "Canada",
    countryCode: "CA",
    timeZoneName: "Atlantic Time",
    abbreviation: "AT (AST/ADT)",
    representativeCity: "Halifax",
    utcOffset: "UTC-04:00",
  },
  {
    timeZoneId: "America/Winnipeg",
    country: "Canada",
    countryCode: "CA",
    timeZoneName: "Central Time",
    abbreviation: "CT (CST/CDT)",
    representativeCity: "Winnipeg",
    utcOffset: "UTC-06:00",
  },
  {
    timeZoneId: "America/Toronto",
    country: "Canada",
    countryCode: "CA",
    timeZoneName: "Eastern Time",
    abbreviation: "ET (EST/EDT)",
    representativeCity: "Toronto",
    utcOffset: "UTC-05:00",
  },
  {
    timeZoneId: "America/Edmonton",
    country: "Canada",
    countryCode: "CA",
    timeZoneName: "Mountain Time",
    abbreviation: "MT (MST/MDT)",
    representativeCity: "Edmonton",
    utcOffset: "UTC-07:00",
  },
  {
    timeZoneId: "America/St_Johns",
    country: "Canada",
    countryCode: "CA",
    timeZoneName: "Newfoundland Time",
    abbreviation: "NT (NST/NDT)",
    representativeCity: "St. John's",
    utcOffset: "UTC-03:30",
  },
  {
    timeZoneId: "America/Vancouver",
    country: "Canada",
    countryCode: "CA",
    timeZoneName: "Pacific Time",
    abbreviation: "PT (PST/PDT)",
    representativeCity: "Vancouver",
    utcOffset: "UTC-08:00",
  },
  // Mexico
  {
    timeZoneId: "America/Mexico_City",
    country: "Mexico",
    countryCode: "MX",
    timeZoneName: "Central Standard Time",
    abbreviation: "CST",
    representativeCity: "Mexico City",
    utcOffset: "UTC-06:00",
  },
  {
    timeZoneId: "America/Monterrey",
    country: "Mexico",
    countryCode: "MX",
    timeZoneName: "Central Standard Time",
    abbreviation: "CST",
    representativeCity: "Monterrey",
    utcOffset: "UTC-06:00",
  },
  {
    timeZoneId: "America/Cancun",
    country: "Mexico",
    countryCode: "MX",
    timeZoneName: "Eastern Standard Time",
    abbreviation: "EST",
    representativeCity: "Cancun",
    utcOffset: "UTC-05:00",
  },
  {
    timeZoneId: "America/Hermosillo",
    country: "Mexico",
    countryCode: "MX",
    timeZoneName: "Mountain Standard Time",
    abbreviation: "MST",
    representativeCity: "Hermosillo",
    utcOffset: "UTC-07:00",
  },
  {
    timeZoneId: "America/Mazatlan",
    country: "Mexico",
    countryCode: "MX",
    timeZoneName: "Mountain Standard Time",
    abbreviation: "MST",
    representativeCity: "Mazatlan",
    utcOffset: "UTC-07:00",
  },
  {
    timeZoneId: "America/Tijuana",
    country: "Mexico",
    countryCode: "MX",
    timeZoneName: "Pacific Time",
    abbreviation: "PST",
    representativeCity: "Tijuana",
    utcOffset: "UTC-08:00",
  },
  // Colombia
  {
    timeZoneId: "America/Bogota",
    country: "Colombia",
    countryCode: "CO",
    timeZoneName: "Colombia Time",
    abbreviation: "COT",
    representativeCity: "Bogota",
    utcOffset: "UTC-05:00",
  },
  // Argentina
  {
    timeZoneId: "America/Argentina/Buenos_Aires",
    country: "Argentina",
    countryCode: "AR",
    timeZoneName: "Argentina Time",
    abbreviation: "ART",
    representativeCity: "Buenos Aires",
    utcOffset: "UTC-03:00",
  },
  // Austria
  {
    timeZoneId: "Europe/Vienna",
    country: "Austria",
    countryCode: "AT",
    timeZoneName: "Central European Time",
    abbreviation: "CET (CET/CEST)",
    representativeCity: "Vienna",
    utcOffset: "UTC+01:00",
  },
  // United Kingdom
  {
    timeZoneId: "Europe/London",
    country: "United Kingdom",
    countryCode: "GB",
    timeZoneName: "Greenwich Mean Time",
    abbreviation: "GMT (GMT/BST)",
    representativeCity: "London",
    utcOffset: "UTC+00:00",
  },
  // Singapore
  {
    timeZoneId: "Asia/Singapore",
    country: "Singapore",
    countryCode: "SG",
    timeZoneName: "Singapore Time",
    abbreviation: "SGT",
    representativeCity: "Singapore",
    utcOffset: "UTC+08:00",
  },
  // China
  {
    timeZoneId: "Asia/Shanghai",
    country: "China",
    countryCode: "CN",
    timeZoneName: "China Standard Time",
    abbreviation: "CST",
    representativeCity: "Beijing",
    utcOffset: "UTC+08:00",
  },
  //Australia
  {
    timeZoneId: "Australia/Sydney",
    country: "Australia",
    countryCode: "AU",
    timeZoneName: "Australian Eastern Time",
    abbreviation: "AEST (AEST/AEDT)",
    representativeCity: "Sydney",
    utcOffset: "UTC+10:00",
  },
  {
    timeZoneId: "Australia/Melbourne",
    country: "Australia",
    countryCode: "AU",
    timeZoneName: "Australian Eastern Time",
    abbreviation: "AEST (AEST/AEDT)",
    representativeCity: "Melbourne",
    utcOffset: "UTC+10:00",
  },
  {
    timeZoneId: "Australia/Brisbane",
    country: "Australia",
    countryCode: "AU",
    timeZoneName: "Australian Eastern Standard Time",
    abbreviation: "AEST",
    representativeCity: "Brisbane",
    utcOffset: "UTC+10:00",
  },
  {
    timeZoneId: "Australia/Hobart",
    country: "Australia",
    countryCode: "AU",
    timeZoneName: "Australian Eastern Time",
    abbreviation: "AEST (AEST/AEDT)",
    representativeCity: "Hobart",
    utcOffset: "UTC+10:00",
  },
  {
    timeZoneId: "Australia/Adelaide",
    country: "Australia",
    countryCode: "AU",
    timeZoneName: "Australian Central Time",
    abbreviation: "ACST (ACST/ACDT)",
    representativeCity: "Adelaide",
    utcOffset: "UTC+09:30",
  },
  {
    timeZoneId: "Australia/Darwin",
    country: "Australia",
    countryCode: "AU",
    timeZoneName: "Australian Central Standard Time",
    abbreviation: "ACST",
    representativeCity: "Darwin",
    utcOffset: "UTC+09:30",
  },
  {
    timeZoneId: "Australia/Perth",
    country: "Australia",
    countryCode: "AU",
    timeZoneName: "Australian Western Standard Time",
    abbreviation: "AWST",
    representativeCity: "Perth",
    utcOffset: "UTC+08:00",
  },
];

export const DEFAULT_TIMEZONE_ID = "Asia/Shanghai";

export const getTimeZoneConfig = (timeZoneId?: string) => {
  if (!timeZoneId) {
    return timeZones.find((item) => item.timeZoneId === DEFAULT_TIMEZONE_ID);
  }

  return timeZones.find((item) => item.timeZoneId === timeZoneId);
};

const buildTimeZoneKey = (category: "name" | "city", timeZoneId: string) => {
  return `timeZoneOptions.${category}.${timeZoneId.replace(/[\/-]/g, "_")}`;
};

const translateWithFallback = (key: string, fallback: string) => {
  if (!i18n?.global) {
    return fallback;
  }

  const translator = i18n.global.t as (translationKey: string) => string;
  const translated = translator(key);
  return translated === key ? fallback : translated;
};

export const formatTimeZoneDisplayText = (
  timeZoneId?: string,
  _locale?: string,
) => {
  if (!timeZoneId) {
    return "";
  }

  const matchedTimeZone = getTimeZoneConfig(timeZoneId);

  if (!matchedTimeZone) {
    return timeZoneId || "";
  }

  const timeZoneName = translateWithFallback(
    buildTimeZoneKey("name", matchedTimeZone.timeZoneId),
    matchedTimeZone.timeZoneName,
  );
  const representativeCity = translateWithFallback(
    buildTimeZoneKey("city", matchedTimeZone.timeZoneId),
    matchedTimeZone.representativeCity,
  );

  return `${matchedTimeZone.utcOffset} ${timeZoneName} (${representativeCity})`;
};

export const formatTimeZoneDetailText = (
  timeZoneId?: string,
  _locale?: string,
) => {
  if (!timeZoneId) {
    return "";
  }

  const matchedTimeZone = getTimeZoneConfig(timeZoneId);

  if (!matchedTimeZone) {
    return timeZoneId || "";
  }

  const representativeCity = translateWithFallback(
    buildTimeZoneKey("city", matchedTimeZone.timeZoneId),
    matchedTimeZone.representativeCity,
  );

  return `${representativeCity}（${matchedTimeZone.utcOffset}）`;
};

export default timeZones;
